// @flow
import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';

import {Typography} from '@material-ui/core';
import makeStyles from '@material-ui/core/styles/makeStyles';

import planExpiringModalImage from '../../../../assets/img/planExpiringModalImage.svg';
import {colors} from '../../../../assets/styles/colors';

import CustomModal from '../../../../elements/CustomModal/CustomModal';
import CustomButton from '../../../../elements/CustomButton/CustomButton';

import type {User, Store} from '../../../../entities';
import type {RootState} from '../../..';
import {useLocation} from 'react-router-dom';
import {generateWhatsappLink} from '../../../../utils/share';
import {useBillingPortalLink} from '../../../tiers/utils';

export default connect(
  (state: RootState) => ({
    store: state.store.store,
    user: state.auth.user,
  }),
  null
)(FreeTrialExpiringModal);

type Props = {
  user?: User,
  store?: Store,
  open: boolean,
  handleClose: () => void,
};

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    width: 600,
    maxWidth: '100%',
    padding: theme.spacing(4, 5, 1, 5),
  },
  title: {
    textAlign: 'center',
    fontSize: '1.5rem',
    fontWeight: 600,
    // lineHeight: '2.5rem',
  },
  purple: {
    color: colors.purple3,
  },
  text: {
    textAlign: 'center',
    fontSize: '1.125rem',
    marginTop: theme.spacing(2),
    color: colors.grey900,
  },
  text2: {
    textAlign: 'center',
    marginTop: theme.spacing(1),
    color: colors.grey900,
  },
  greyBox: {
    marginTop: theme.spacing(5),
    padding: theme.spacing(3, 4),
    backgroundColor: colors.grey200,
    borderRadius: '12px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  greyBoxText: {
    fontSize: '1.125rem',
    fontWeight: 600,
    color: colors.grey900,
  },
  button: {
    height: 48,
    // marginTop: theme.spacing(3),
    fontSize: '1.125rem',
    fontWeight: 600,
    padding: '4px 80px',
    maxWidth: '100%',
  },
}));

function FreeTrialExpiringModal(props: Props) {
  const {open, handleClose, user, store} = props;
  const classes = useStyles();

  const location = useLocation();
  const upgradePaths = ['/tiers-list', '/checkout', '/checkout/payment'];

  const {billingLink} = useBillingPortalLink();

  return (
    !upgradePaths.includes(location.pathname) && (
      <CustomModal open={open} handleCloseModal={handleClose}>
        <div className={classes.root}>
          <Typography className={`${classes.title} ${classes.purple}`}>
            {user ? user.firstName : ''}
          </Typography>
          <Typography className={classes.title}>
            Tu periodo de prueba está por terminar
          </Typography>
          <Typography className={classes.text} align="center">
            Renueva ahora y sigamos impulsando tu negocio.
          </Typography>
          <div className={classes.greyBox}>
            <Typography className={classes.greyBoxText} align="center">
              Es momento de decidir si TiendaDa es el aliado para{' '}
              {store && store.name}.
            </Typography>
            <img src={planExpiringModalImage} alt="" />
          </div>
          <Typography className={classes.text2} align="center">
            *Si renuevas hoy, tu nuevo plan empezará cuando finalize tu periódo
            de prueba.
          </Typography>
          <br />
          <br />
          {billingLink && (
            <CustomButton
              variant="contained"
              color="primary"
              className={classes.button}
              onClick={handleClose}
              component="a"
              href={billingLink}
            >
              Gestionar mi subscripción
            </CustomButton>
          )}
          <CustomButton
            color="primary"
            className={classes.button}
            // onClick={handleClose}
            href={generateWhatsappLink(
              '51972076020',
              'Hola, necesito ayuda para elegir un plan.'
            )}
            target="_blank"
            rel="noopener noreferrer"
          >
            Hablar con un asesor
          </CustomButton>
        </div>
      </CustomModal>
    )
  );
}

FreeTrialExpiringModal.propTypes = {
  user: PropTypes.object,
  store: PropTypes.object,
  open: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
};
